"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPathAlias = getPathAlias;
exports.getModelImagePath = getModelImagePath;
exports.getModelUrl = getModelUrl;
exports.getModelsOfGroup = getModelsOfGroup;
exports.getModelGroups = getModelGroups;
exports.getVehicleForBrand = getVehicleForBrand;
exports.getVehiclesYears = getVehiclesYears;
exports.getLatestYear = getLatestYear;
exports.getVehicleModels = getVehicleModels;
exports.getBrandTheme = getBrandTheme;
exports.getVehicleInfo = getVehicleInfo;

var _index = require("../index");

var _lodash = _interopRequireDefault(require("lodash"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}
/**
 * Get converted path by group/model/etc name
 * @param {string} name - Model/Group/etc name
 * @returns {string}
 */


function getPathAlias(name) {
  return name ? name.toLowerCase().replace(/\W+/g, "-") : "";
}
/**
 * Get Model image path
 *
 * @deprecated - the hero-shots were used in Nissan app and were removed recently
 *               the function is recommended for removal
 *
 * @param {string} brand - Brand/Make name
 * @param {string} model - Model name
 * @param {string} year  - Model year
 * @returns {string}
 */


function getModelImagePath(brand, model, year) {
  var _getConfig = (0, _index.getConfig)(),
      DEFAULT_BRAND = _getConfig.DEFAULT_BRAND; // as we don't have model/year icons differentiation for now
  // we just share the same icons for all years


  year = 'all';
  brand = brand || DEFAULT_BRAND;
  return "".concat(year, "-").concat(brand.toLowerCase(), "-").concat(getPathAlias(model));
}
/**
 * Get Model URL for routing and links
 * @param {string} year  - Model year
 * @param {string} model - Model name
 * @returns {string}
 */


function getModelUrl(year, model) {
  return "/".concat(year, "/").concat(model ? getPathAlias(model) : "");
}
/**
 * Get all models of current group
 * @todo Replace with real group data from API (and use normalizr)
 * @param {array} models - Models array
 * @param {string} group - Current group name to collect models
 * @returns {Array.<*>}
 */


function getModelsOfGroup(models, group) {
  var _getConfig2 = (0, _index.getConfig)(),
      TEMPORARY_GROUPS = _getConfig2.TEMPORARY_GROUPS;

  var groupModels = [];

  for (var i = 0; i < models.length; i++) {
    if (TEMPORARY_GROUPS[models[i]] && TEMPORARY_GROUPS[models[i]] === group) {
      if (groupModels.indexOf(models[i]) === -1) groupModels.push(models[i]);
    }
  }

  return groupModels.sort();
}
/**
 * Get all groups from models array
 * @todo replace with actual grouping data from API (and use normalizr)
 *
 * @param {array} models - Models array
 * @returns {Array.<*>}
 */


function getModelGroups(models) {
  var _getConfig3 = (0, _index.getConfig)(),
      TEMPORARY_GROUPS = _getConfig3.TEMPORARY_GROUPS;

  var groups = [];

  for (var i = 0; i < models.length; i++) {
    if (TEMPORARY_GROUPS[models[i]]) {
      if (groups.indexOf(TEMPORARY_GROUPS[models[i]]) === -1) groups.push(TEMPORARY_GROUPS[models[i]]);
    }
  }

  return groups.sort();
}
/**
 * Returns the list of vehicles for particular brand
 *
 * @param {Array} vehicles
 * @param {String} brand
 * @returns {Array}
 */


function getVehicleForBrand(vehicles, brand) {
  var _getConfig4 = (0, _index.getConfig)(),
      DEFAULT_BRAND = _getConfig4.DEFAULT_BRAND;

  brand = brand || DEFAULT_BRAND;
  return vehicles.filter(function (item) {
    return item.make === brand;
  });
}
/**
 * Returns the list of years available out of the provided vehicles
 *
 * @param {Array} vehicles
 * @return {Array}
 */


function getVehiclesYears(vehicles) {
  return _lodash.default.reverse(_lodash.default.sortBy(_lodash.default.uniq(vehicles.map(function (data) {
    return data.year;
  }))));
}
/**
 * Returns the latest year from the list of content years
 *
 * Our content years could contain the full year vehicle programs like "2019", "2018" and half-year releases "2018.5"
 *
 * When choosing the latest year we should ignore the half-year releaes and only select the most recent year
 * from those where we have a vehicles content for.
 *
 * @param {String[]} years
 * @return {String}
 */


function getLatestYear(years) {
  return Math.max.apply(Math, _toConsumableArray(years.filter(function (x) {
    return /^\d{4}$/.test(x);
  }) // get rid of half-years
  .map(function (x) {
    return parseInt(x, 10);
  }))).toString();
}
/**
 * Returns the list of models available out of the provided vehicles for specified year
 *
 * @param {Array} vehicles
 * @param {String} year
 * @return {Array}
 */


function getVehicleModels(vehicles, year) {
  return vehicles.filter(function (item) {
    return item.year === year;
  }).map(function (i) {
    return i.model;
  });
}
/**
 * Initialize brand theme (required only for <Loader /> component)
 * TODO: replace by native loader with brand specific theme
 *
 * @return {String}
 */


function getBrandTheme() {
  var _getConfig5 = (0, _index.getConfig)(),
      DEFAULT_BRAND = _getConfig5.DEFAULT_BRAND;

  if (!window.localStorage) {
    return DEFAULT_BRAND;
  }

  var themeKey = 'persist:root';
  return window.localStorage[themeKey] ? JSON.parse(JSON.parse(window.localStorage[themeKey]).vehicle).currentBrand : DEFAULT_BRAND;
}
/**
 * Gets vehicle info
 *
 * @param {[{id: {String}, make: {String}, year: {String}, model: {String}, FOREST_RIVER_PRODUCT_TYPE: {String}, FOREST_RIVER_PRODUCT_SUB_TYPE: {String}}]} vehicles
 * @param {String} id
 * @param {String} year
 * @param {String} brand
 * @param {String} model
 * @param {String} [productType]
 * @param {String} [productSubtype]
 *
 * @return {Object}
 */


function getVehicleInfo(vehicles, id, year, brand, model, productType, productSubtype) {
  return vehicles.find(function (v) {
    return v.id === id && v.year === year && v.make === brand && v.model === model && (productType && v.FOREST_RIVER_PRODUCT_TYPE ? v.FOREST_RIVER_PRODUCT_TYPE === productType : true) && (productSubtype && v.FOREST_RIVER_PRODUCT_SUB_TYPE ? v.FOREST_RIVER_PRODUCT_SUB_TYPE === productSubtype : true);
  });
}